import { render, staticRenderFns } from "./SkeletonInstructorDetails.vue?vue&type=template&id=4af8219c"
import script from "./SkeletonInstructorDetails.vue?vue&type=script&lang=js"
export * from "./SkeletonInstructorDetails.vue?vue&type=script&lang=js"
import style0 from "./SkeletonInstructorDetails.vue?vue&type=style&index=0&id=4af8219c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports